import React, { useEffect, memo, useState, useCallback } from 'react';
import { mapToCssModules } from '../../../utils/className';
const Toast = ({ message, className, removeToast, timer }) => {
    const [exit, setExit] = useState(false);
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (!exit) {
            const timerTimeout = setTimeout(() => {
                setExit(true);
                setTimeout(() => removeToast(message.id), 1000);
            }, timer);
            return () => clearTimeout(timerTimeout);
        }
    }, [exit]);
    const removeWhenClick = useCallback(() => {
        setExit(true);
        setTimeout(() => removeToast(message.id), 1000);
    }, []);
    return (React.createElement("div", { className: mapToCssModules([
            'smsls-custom-toast',
            className,
            message.description ? 'hasdescription' : '0',
            exit ? 'hidden' : '',
        ]), onClick: removeWhenClick },
        React.createElement("div", null,
            React.createElement("span", null, message.description)),
        React.createElement("i", { className: "material-icons" }, "check")));
};
export default memo(Toast);
//# sourceMappingURL=index.js.map